module.exports = __webpack_public_path__ + "img/mtbd_2.8e956e4b.png";